import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  popoverContainer: {
    padding: 12,
  },
}));
